import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import PageHeader from "../components/pageHeader";
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";


const Currency = () => {

    // State variables to manage button visibility
    const [showSubmitButton, setShowSubmitButton] = useState(true);
    const [showUpdateButton, setShowUpdateButton] = useState(false);
     // State variable to control readonly status of currency and icon input fields
     const [readOnlyFields, setReadOnlyFields] = useState(false);

    const [newdata, setNewdata] = useState({
        id:"", currency: "", country: "", value: "", icon: "", code: "",
    });
    const { currency, value, icon, code } = newdata;

    const [dataCurrency, setDataCurrency] = useState([]);

    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/CurrencyList/Get-GetCurrencyDetails', setDataCurrency);

    }, [dataCurrency]);

    const columns = [
        {
            width: "50px",
            cell: row => (
                <div>
                    {/* Display the country name and flag */}
                    <ReactCountryFlag countryCode={row.code} svg style={{ width: '2em', height: '2em' }} />
                </div>
            )
        },
        {            
            name: "Currency",
            selector: row => row.currency,
            sortable: true, 
            width: "100px",           
        },
        {
            name: "Value",
            selector: row => row.value,            
            maxWidth:"100px",
        },
        {
            name: "icon",
            selector: row => row.icon,            
            maxWidth:"100px",
        },
        {
            name: "Action",
            cell: (row) => (
                <div>
                    <Link to={``} onClick={() => onStatusClick(row.id)}>
                        <img
                            src={row.status === 1 ? "/images/ImgActive.gif" : "/images/ImgInActive.gif"}
                            alt="Change Status"
                            title="Change Status"
                            style={{ width: "50px", height: "25px" }}
                        />
                    </Link>

                    {' '} {' '}{' '} {' '}{' '} {' '}{' '} {' '}
                    <Link to={``} onClick={(event) => onEditClick(row.id)}>
                        <img
                            src="/images/ImgEdit.ico" // Set the correct image source
                            alt="Edit"
                            title="Edit"
                            style={{ width: "30px", height: "30px" }}
                        />
                    </Link>
                </div>
            ),
            maxWidth:"200px",

        },
    ];

    const onStatusClick = async(id)=>{

        const confirmed = window.confirm("Are you sure you want to change Currency status?");
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        try {
            
            const response = await fetch('https://igapi.heuristticminds.com/api/CurrencyList/Update-ChangeCurrencyStatus?id=' + id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                fetchData('https://igapi.heuristticminds.com/api/CurrencyList/Get-GetCurrencyDetails', setDataCurrency);
            }
        }
        catch {
        }
    }

    const onEditClick = async(id)=>{
        debugger;
        const url = 'https://igapi.heuristticminds.com/api/CurrencyList/Get-GetCurrencyDetailsToEditByID?id=' + id;
        const response = await fetch(url);
        if (response.ok) {
            const data = await response.json();
            if (data && typeof data === "object" && Object.keys(data).length > 0) {
                //const currencyData = data[0];
                setNewdata({
                    ...newdata, // Preserving other state in case it's needed
                    id: data.id,
                    currency: data.currency,
                    value: data.value,
                    icon: data.icon,
                    code: data.code,
                });
                // Set currency and icon input fields as readonly
                setReadOnlyFields(true);
            } else {
                console.log("No data received for id:", id);
            }
        } else {
            console.error("Failed to fetch currency details for editing:", response.statusText);
        }
        setShowSubmitButton(false);
        setShowUpdateButton(true);
    };

    const handleCurrencyChange = (event) => {
        setNewdata({ ...newdata, currency: event.target.value });
    };
    const handleValueChange = (event) => {
        setNewdata({ ...newdata, value: event.target.value });
    };
    const handleIconChange = (event) => {
        setNewdata({ ...newdata, icon: event.target.value });
    };
    const handleCountryChange = (event) => {
        setNewdata({ ...newdata, country: event.target.value });
    };
    const handleCodeChange = (event) => {
        setNewdata({ ...newdata, code: event.target.value });
    };

    const handleUpdate = async()=>{

         const confirmed = window.confirm("Are you sure you want to change currency value ?");
         if (!confirmed) {
             return; // If not confirmed, return early without deleting
         }
        try {
            
            const response = await fetch('https://igapi.heuristticminds.com/api/CurrencyList/Update-UpdateCurrencyValue?id='+ newdata.id+'&value='+ newdata.value, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                setNewdata({ currency: "", country: "", value: "", icon: "", code: "" });
                fetchData('https://igapi.heuristticminds.com/api/CurrencyList/Get-GetCurrencyDetails', setDataCurrency);
            }
        }
        catch {
        }
        setShowSubmitButton(true);
        setShowUpdateButton(false);
        setReadOnlyFields(false);
    };

    const handleSubmit = async()=> {
        // Check if both title and policyDetails are not empty
        if (currency.trim() === '' || value.trim() === '' || code.trim() === '' || icon.trim() === '') {
            alert('Please fill in all fields.'); // You can replace this with a more sophisticated validation message
            return; // Prevent form submission if validation fails
        }
        const formData = {

            "currency": currency,
            "value": value,
            "icon": icon,
            "code": code
        };
        try {
            // Make the API call to save the form data
            const response = await fetch('https://igapi.heuristticminds.com/api/CurrencyList/Add-SaveCurrencyDetails', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {                
                
                setNewdata({ currency: "", country: "", value: "", icon: "", code: "" });
                const confirmed = window.confirm("Currency Details Saved Successfully !!!");
                
                

            } else {
                // Handle error cases
                console.error('Error saving form data:', response.statusText);
            }
        } catch (error) {
            console.error('Error saving form data:', error);
        }

    };

    return(

        <>
            <Header />
        <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">

                    <PageHeader name='Currency' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4 vh-100">
                                    <div className="card-header">Currency Details</div>
                                    <div className="card-body">
                                    
                                    <div className="row">
                                        
                                        <div className="col-sm-2 form-group mb-2">
                                            <label>Currency <span style={{ color: "#ff0000" }}>*</span></label>
                                        </div>
                                        <div className="col-sm-2 form-group mb-2">
                                            <label>Value <span style={{ color: "#ff0000" }}>*</span></label>
                                        </div>
                                        <div className="col-sm-2 form-group mb-2">
                                            <label>Icon <span style={{ color: "#ff0000" }}>*</span></label>
                                        </div>
                                        <div className="col-sm-2 form-group mb-2">
                                            <label>Country Code<span style={{ color: "#ff0000" }}>*</span></label>
                                        </div>
                                        <div className="col-sm-4 form-group mb-4">
                                        
                                        </div>
                                        
                                               
                                    </div>
                                            
                                    <div className="pb-2">
                                    <div className="row">
                                            
                                            <div className="col-sm-2 form-group mb-2">
                                                
                                                <input type="text"
                                                    name="currency"
                                                    value={currency}
                                                    className="form-control"
                                                    maxLength={3}
                                                    placeholder="Currency"
                                                    onChange={handleCurrencyChange} 
                                                    readOnly={readOnlyFields} // Set readOnly based on readOnlyFields state
                                                    />
                                            </div>
                                            <div className="col-sm-2 form-group mb-2">
                                                
                                                <input type="text"
                                                    name="value"
                                                    value={value}
                                                    className="form-control"
                                                    maxLength={6}
                                                    placeholder="Value"
                                                    onChange={handleValueChange} />
                                            </div>
                                            <div className="col-sm-2 form-group mb-2">
                                                
                                                <input type="text"
                                                    name="icon"
                                                    value={icon}
                                                    className="form-control"
                                                    maxLength={1}
                                                    placeholder="Currency Icon"
                                                    onChange={handleIconChange} 
                                                    readOnly={readOnlyFields} // Set readOnly based on readOnlyFields state
                                                    />
                                            </div>
                                            
                                            <div className="col-sm-2 form-group mb-2">
                                                
                                                <input type="text"
                                                    name="code"
                                                    value={code}
                                                    className="form-control"
                                                    maxLength={2}
                                                    placeholder="Country Code"
                                                    onChange={handleCodeChange} 
                                                    readOnly={readOnlyFields} // Set readOnly based on readOnlyFields state
                                                    />
                                            </div>
                                            <div className="col-sm-4 form-group mb-4">
                                            <button type="button" onClick={handleSubmit} 
                                             className={`btn btn-primary w-50 ${showSubmitButton ? '' : 'd-none'}`}>Submit</button>
                                            <button type="button" onClick={handleUpdate} className={`btn btn-primary w-50 ${showUpdateButton ? '' : 'd-none'}`}>Update</button>                                              
                                            </div>
                                            </div>
                                            
                                    </div>
                                    <div className="ps-2 pe-2">
                                    <DataTable 
                                                    columns={columns}
                                                    data={dataCurrency}
                                                /> 
                                    </div>
   
                                    </div>
                                    </div>
                                    
                                    
                                    
                                
                            </div>

                        </div>
                    </div>
                    </div>
                    <Footer />
                </div>
            
        </>
        
    )
};
export default Currency;